import React, { useState, useEffect, useMemo } from "react";
import { Grid, TextField, Typography, Button, FormControl, MenuItem, makeStyles, Select, InputLabel, OutlinedInput, Checkbox, ListItemText, CircularProgress, IconButton } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { inputFieldStyles, commonInlineStyles } from "../../styles";
import axios from "axios";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { appUrl } from "../../../../../../../utils/config";
import { useApiBaseUrl } from "../../../CommonMethods/CommonMethods";
const useStyles = makeStyles((theme) => ({
  formTitle: {
    marginBottom: theme.spacing(4),
    fontWeight: 700,
    fontSize: 32,
    position: 'relative',
  },
  formField: {
    width: "100%",
    marginBottom: 0,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
    },
  },
  button: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
  },
  backButton: {
    minWidth: 180,
    // fontWeight: 600,
    // fontSize: 16,
    borderRadius: 30,
    // height: 44,
    background: '#707070',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
  selectionsBox: {
    minHeight: 80,
    fontSize: 16,
    padding: 8,
    background: '#fafafa',
    border: '1px solid #ccc',
    borderRadius: 4,
    marginTop: 4,
    marginBottom: 16,
    whiteSpace: 'pre-line',
  },
  selectContainer: {
    '& .MuiOutlinedInput-root': {
      padding: '0 !important',
      '& .MuiSelect-select': {
        padding: '12px 14px !important',
        boxSizing: 'border-box !important',
      },
      '& fieldset': {
        border: '1px solid #ccc !important',
      },
      '&:hover fieldset': {
        border: '1px solid #FF6D00 !important', // Orange hover
      },
      '&.Mui-focused fieldset': {
        border: '2px solid #FF6D00 !important', // Slightly thicker when focused
        outline: 'none !important',
      },
    },
    // Fix for the notch
    '& .MuiOutlinedInput-notchedOutline': {
      top: 0,
      '& legend': {
        display: 'none !important',
      },
    },
  },
}));

const orgOptions = [
  '2821 / USA 2810',
  '3000 / Best Run USA',
  '3001 / Best Run USA ED',
  '3010 / Euro Subsidiary - Be',
  '3050 / Best Run UK 2',
];
const groupOptions = [
  '000 / Chef, H. - 069/5510',
  '001 / Dickens, B. - 069/5511',
  '002 / IDES USA - 040/1001',
  '003 / Eileff, J. - 040/1002',
  '004 / Diller, M. - 069/1300',
  '005 / Davis, L. - 040/1003',
];
const poDocTypes = ['ZTM', 'ZPO', 'ZIN'];

const PurchasingDetails = (props) => {
  const { updateStepData, handleNext, handleBack, formData, readOnly = false, hideStepActions = false, selectedCMOFormData, originalVendorPlantDetails } = props;
  const classes = useStyles();
  const [stepData, setStepData] = useState({ ...formData });
  const [purchasingDetails, setPurchasingDetails] = useState(null);
  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedPoDocTypes, setSelectedPoDocTypes] = useState([]);
  const [poDocTypes, setPoDocTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [brandOwnerMosymphonyID, setBrandOwnerMosymphonyID] = useState("");
  const API_BASE_URL = useApiBaseUrl(appUrl)


  const cmoDetailsResponse = JSON.parse(sessionStorage.getItem("cmoDetailsResponse"));

  const token = localStorage.getItem('authToken');
  useEffect(() => {

    if (token) {
      try {
        const base64Url = token.split('.')[1]; // Get payload
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
            .join('')
        );

        const payload = JSON.parse(jsonPayload);

        setBrandOwnerMosymphonyID(payload.organization_id)

      } catch (e) {
        console.error('Invalid token', e);
      }
    }
  }, [token]);

  useEffect(() => {
    const fetchPurchasingDetails = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/fetchPurchasingDetails`);
        if (response.data?.status) {
          setPurchasingDetails(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching purchasing details:", error);
      }
    };

    const fetchPODocumentTypes = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/fetchPODocumentTypes`);
        if (response.data?.status) {
          setPoDocTypes(response.data.data.poDocumentTypeList);
        }
      } catch (error) {
        console.error("Error fetching PODocument Types:", error);
      }
    };

    fetchPurchasingDetails();
    fetchPODocumentTypes();

  }, []);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setStepData(prev => ({ ...prev, [name]: value }));
    if (typeof updateStepData === 'function') {
      updateStepData({ ...stepData, [name]: value });
    }

    // Clear validation errors when a field is changed
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleOrgChange = (event) => {
    const selectedValues = event.target.value;
    setSelectedOrgs(selectedValues);

    // Get available groups for the new selection
    const availableGroups = [];
    if (purchasingDetails?.purchasingOrgDetails) {
      purchasingDetails.purchasingOrgDetails.forEach(org => {
        // Check if the selectedValues includes the org code and description, allowing for commas
        const orgString = `${org.purchasingOrgCode} / ${org.purchasingOrgDescription}`;
        if (selectedValues.some(val => val.includes(orgString))) {
          org.purchasingGroupDetails.forEach(group => {
            availableGroups.push(`${group.purchasingGroupCode} / ${group.purchasingGroupDescription} - ${group.purchasingGroupTelephone}`);
          });
        }
      });
    }

    // Filter existing selected groups to keep only those that are still available
    const filteredSelectedGroups = selectedGroups.filter(group => availableGroups.includes(group));
    setSelectedGroups(filteredSelectedGroups);

    setStepData(prev => ({
      ...prev,
      purchasingOrgList: selectedValues.map(org => {
        // Split by first occurrence of ' / ' to handle commas in description
        const parts = org.split(' / ');
        const code = parts[0];
        const description = parts.slice(1).join(' / '); // Join back any remaining parts
        return { code, description };
      }),
      purchasingGroupList: filteredSelectedGroups.map(group => {
        // Split by first occurrence of ' / ' to handle commas in description
        const parts = group.split(' / ');
        const code = parts[0];
        const restParts = parts.slice(1).join(' / ');
        // Split by first occurrence of ' - ' to handle commas in telephone
        const [description, telephoneNbr] = restParts.split(' - ');
        return { code, description, telephoneNbr };
      })
    }));

    if (errors.purchasingOrg) {
      setErrors(prev => ({ ...prev, purchasingOrg: '' }));
    }
  };

  const handleGroupChange = (event) => {
    const selectedValues = event.target.value;
    setSelectedGroups(selectedValues);
    setStepData(prev => ({
      ...prev,
      purchasingGroupList: selectedValues.map(group => {
        // Split by first occurrence of ' / ' to handle commas in description
        const parts = group.split(' / ');
        const code = parts[0];
        const restParts = parts.slice(1).join(' / ');
        // Split by first occurrence of ' - ' to handle commas in telephone
        const [description, telephoneNbr] = restParts.split(' - ');
        return { code, description, telephoneNbr };
      })
    }));
    if (errors.purchasingGroup) {
      setErrors(prev => ({ ...prev, purchasingGroup: '' }));
    }
  };

  const handlePoDocTypeChange = (event) => {
    const selectedValues = event.target.value;
    setSelectedPoDocTypes(selectedValues);
    setStepData(prev => ({
      ...prev,
      poDocType: selectedValues
    }));
    if (errors.poDocType) {
      setErrors(prev => ({ ...prev, poDocType: '' }));
    }
  };

  useEffect(() => {
    // Initialize selected values from formData if available
    if (formData) {
      if (formData.poDocType) {
        setSelectedPoDocTypes(formData.poDocType);
      }
      if (formData.purchasingOrgList) {
        const orgs = formData.purchasingOrgList.map(org => `${org.code} / ${org.description}`);
        setSelectedOrgs(orgs);
      }
      if (formData.purchasingGroupList) {
        const groups = formData.purchasingGroupList.map(group =>
          `${group.code} / ${group.description} - ${group.telephoneNbr}`);
        setSelectedGroups(groups);
      }
    }
  }, [formData]);

  const validateFields = () => {
    const newErrors = {};
    let isValid = true;

    // Company Code validation
    // if (!stepData.companyCode || !stepData.companyCode.trim()) {
    //   newErrors.companyCode = "Company Code is required";
    //   isValid = false;
    // } 
     if (stepData.companyCode && !/^[A-Za-z0-9]{1,10}$/.test(stepData.companyCode)) {
      newErrors.companyCode = "Company Code must be alphanumeric only, maximum 10 characters";
      isValid = false;
    }

    // CMO ID validation
    if (!stepData.cmoIDFromSponsorERP || !stepData.cmoIDFromSponsorERP.trim()) {
      newErrors.cmoIDFromSponsorERP = "CMO ID from Sponsor ERP is required";
      isValid = false;
    } else {
      const cmoIdsArray = (stepData?.cmoIDFromSponsorERP || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);

      if (cmoIdsArray.length === 0) {
        newErrors.cmoIDFromSponsorERP = "At least one CMO ID is required";
        isValid = false;
      } else {
        // Check for duplicates first
        const duplicates = checkForDuplicateCmoIds(cmoIdsArray);
        if (duplicates.length > 0) {
          newErrors.cmoIDFromSponsorERP = `Duplicate CMO IDs found: ${duplicates.join(", ")}. Each CMO ID must be unique.`;
          isValid = false;
        } else {
          // Check format validation only if no duplicates
          cmoIdsArray.forEach((id) => {
            if (!/^[A-Za-z0-9\-_]{1,15}$/.test(id)) {
              newErrors.cmoIDFromSponsorERP =
                "Each CMO ID must be alphanumeric and may include hyphens (-) and underscores (_) only, max 15 characters";
              isValid = false;
            }
          });
        }
      }
    }


    // PO Document Type validation
    // if (!selectedPoDocTypes || selectedPoDocTypes.length === 0) {
    //   newErrors.poDocType = "At least one PO Document Type must be selected";
    //   isValid = false;
    // }

    // Purchasing Org validation
    // if (!selectedOrgs || selectedOrgs.length === 0) {
    //   newErrors.purchasingOrg = "At least one Purchasing Organization must be selected";
    //   isValid = false;
    // }

    // Purchasing Group validation
    // if (!selectedGroups || selectedGroups.length === 0) {
    //   newErrors.purchasingGroup = "At least one Purchasing Group must be selected";
    //   isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };

  // Custom handlers for specific fields
  const handleCompanyCodeChange = (e) => {
    // Restrict to alphanumeric only
    const value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
    if (value.length <= 10) { // Max 10 characters allowed
      setStepData(prev => ({ ...prev, companyCode: value }));
      if (errors.companyCode) {
        setErrors(prev => ({ ...prev, companyCode: '' }));
      }
    }
  };

  // const handleCmoIdChange = (e) => {
  //   // Restrict to alphanumeric, hyphen, and underscore
  //   const value = e.target.value.replace(/[^A-Za-z0-9\-_]/g, '');
  //   if (value.length <= 15) { // Max 15 characters allowed
  //     setStepData(prev => ({ ...prev, cmoIDFromSponsorERP: value }));
  //     if (errors.cmoIDFromSponsorERP) {
  //       setErrors(prev => ({ ...prev, cmoIDFromSponsorERP: '' }));
  //     }
  //   }
  // };
  // stepData.cmoIDFromSponsorERP

    const [cmoIds, setCmoIds] = useState(
      stepData.cmoIDFromSponsorERP
        ? stepData.cmoIDFromSponsorERP.split(",").map((id) => id.trim())
        : [""]
    );

    const checkForDuplicateCmoIds = (cmoIdsArray) => {
  const trimmedIds = cmoIdsArray.map(id => id.trim().toLowerCase()).filter(Boolean);
  const duplicates = trimmedIds.filter((id, index) => trimmedIds.indexOf(id) !== index);
  return duplicates.length > 0 ? [...new Set(duplicates)] : [];
};

      const handleDynamicCmoIdChange = (index, value) => {
  const cleanedValue = value.replace(/[^A-Za-z0-9\-_]/g, "");
  if (cleanedValue.length <= 15) {
    const updated = [...cmoIds];
    updated[index] = cleanedValue;
           // Check for duplicates
    const duplicates = checkForDuplicateCmoIds(updated);
    if (duplicates.length > 0) {
      setErrors((prev) => ({ 
        ...prev, 
        cmoIDFromSponsorERP: `CMO ID already exists: ${duplicates.join(", ")}. Please enter a different CMO ID.` 
      }));
    } else {
      // Clear duplicate error if no duplicates found
      setErrors((prev) => ({ 
        ...prev, 
        cmoIDFromSponsorERP: "" 
      }));
    }
 setCmoIds(updated);
    // also keep your existing form logic updated as comma-separated string
    const newString = updated.filter(Boolean).join(",");
    setStepData((prev) => ({ ...prev, cmoIDFromSponsorERP: newString }));
    // setFormChanged(true);
    // if (onChange) onChange({ ...form, cmoIDFromSponsorERP: newString });

    if (errors.cmoIDFromSponsorERP) {
      setErrors((prev) => ({ ...prev, cmoIDFromSponsorERP: "" }));
    }
  }
};

const handleAddCmoId = (index) => {
  // prevent adding if any field is empty
  if (cmoIds.some((id) => id.trim() === "")) {
    return;
  }
  const updated = [...cmoIds,""];
  // updated.splice(index + 1, 0, ""); // insert new field after clicked index
  setCmoIds(updated);
  //   if (errors.cmoIDFromSponsorERP) {
  //   setErrors((prev) => ({ ...prev, cmoIDFromSponsorERP: "" }));
  // }
};

const handleRemoveCmoId = (index) => {
  const updated = cmoIds.filter((_, i) => i !== index);
  setCmoIds(updated);

  // sync to form
  const newString = updated.filter(Boolean).join(",");
  setStepData((prev) => ({ ...prev, cmoIDFromSponsorERP: newString }));

    const remainingIds = updated.filter(Boolean);
 if (remainingIds.length > 0) {
   const duplicates = checkForDuplicateCmoIds(remainingIds);
   if (duplicates.length > 0) {
     setErrors((prev) => ({
       ...prev,
       cmoIDFromSponsorERP: `Duplicate CMO IDs found: ${duplicates.join(
         ", "
       )}. Each CMO ID must be unique.`,
     }));
   } else {
     // Only clear error if no duplicates found
     setErrors((prev) => ({ ...prev, cmoIDFromSponsorERP: "" }));
   }
 } else {
   // Clear error if no CMO IDs left
   setErrors((prev) => ({ ...prev, cmoIDFromSponsorERP: "" }));
 }
};

  // Get available groups for selected orgs
  const getAvailableGroups = () => {
    if (!purchasingDetails?.purchasingOrgDetails) return [];

    const groups = [];
    purchasingDetails.purchasingOrgDetails.forEach(org => {
      if (selectedOrgs.includes(`${org.purchasingOrgCode} / ${org.purchasingOrgDescription}`)) {
        org.purchasingGroupDetails.forEach(group => {
          groups.push(`${group.purchasingGroupCode} / ${group.purchasingGroupDescription} - ${group.purchasingGroupTelephone}`);
        });
      }
    });
    return groups;
  };


  const handleNextClick = async () => {
    setSubmitted(true); // Mark as submitted to trigger validation

    if (!validateFields()) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const payload = {
        vendorMosymphonyID: cmoDetailsResponse?.organizationId,
        brandOwnerMosymphonyID: brandOwnerMosymphonyID,
        updateCMOPurchasingDetailsFlag: true,
        // updateStatusFlag: true,
        vendorPlantDetails: {
          companyCode: stepData.companyCode,
          poDocumentTypesList: Array.isArray(stepData.poDocType) ? stepData.poDocType : [stepData.poDocType],
          purchasingOrgList: selectedOrgs.map(org => {
            // Split by first occurrence of ' / ' to handle commas in description
            const parts = org.split(' / ');
            const purchasingOrgCode = parts[0];
            const purchasingOrgDescription = parts.slice(1).join(' / '); // Join back any remaining parts
            return { purchasingOrgCode, purchasingOrgDescription };
          }),
          purchasingGroupList: selectedGroups.map(group => {
            // Split by first occurrence of ' / ' to handle commas in description
            const parts = group.split(' / ');
            const purchasingGroupCode = parts[0];
            const restParts = parts.slice(1).join(' / ');
            // Split by first occurrence of ' - ' to handle commas in telephone
            const [purchasingGroupDescription, purchasingGroupTelephone] = restParts.split(' - ');
            return { purchasingGroupCode, purchasingGroupDescription, purchasingGroupTelephone };
          }),
          cmoIDFromSponsorERP: stepData.cmoIDFromSponsorERP,
          receivingPlantIDs: [],
          receivingStorageLocationIDs: [],
        }
      };

      await axios.post(`${API_BASE_URL}/updateVendorPlantDetails`, payload);
      updateStepData(stepData);
      handleNext();
    } catch (err) {
      setError("Failed to update purchasing details. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="cmo-stepper-wrapper">
      <div className="stepper-container">
        <form>          <Typography variant="h6" className={classes.formTitle}>
          Purchasing Details
        </Typography>
          {/* {error && <Typography color="error" style={{ marginBottom: 16 }}>{error}</Typography>}
          {submitted && Object.keys(errors).length > 0 && (
            <Typography color="error" style={{ marginBottom: 16 }}>
              Please correct the errors below before proceeding.
            </Typography>
          )} */}
          <Grid className="two-col-forms-grid" container spacing={3}>
            {/* Company Code */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="companyCode">
                  Company Code
                  {/* Company Code {!readOnly && <span style={{ color: "red" }}>*</span>} */}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.companyCode || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="companyCode"
                    name="companyCode"
                    value={stepData.companyCode || ''}
                    onChange={handleCompanyCodeChange}  
                    onBlur={(e) => {
                      const { value } = e.target;
                      // Trim leading and trailing spaces for string values
                      if (typeof value === "string" && value.trim() !== value) {
                        handleCompanyCodeChange({ target: { name: "companyCode", value: value.trim() } });
                      }
                    }}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    }}
                    sx={inputFieldStyles}
                    inputProps={commonInlineStyles.inputProps}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.companyCode)}
                  />
                )}
                {submitted && errors.companyCode && (
                  <Typography color="error" variant="caption" style={{ fontSize: 14 }}>
                    {errors.companyCode}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            {/* PO Document Type */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="poDocType">
                PO Document Type
                  {/* PO Document Type {!readOnly && <span style={{ color: "red" }}>*</span>} */}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {Array.isArray(formData?.poDocType) ? formData?.poDocType?.join(", ") : "N/A"}
                  </Typography>
                ) : (
                  <Select
                    multiple
                    id="poDocType"
                    name="poDocType"
                    value={selectedPoDocTypes || ""}
                    className={classes.selectContainer}
                    onChange={handlePoDocTypeChange}
                    input={<OutlinedInput label="PO Document Type" notched={false} />}
                    renderValue={(selected) =>
                      selected.length === 0 ? "Select from the list" : selected.join(", ")
                    }
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    }}
                    fullWidth
                    required
                    sx={inputFieldStyles}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.poDocType)}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      }
                    }}

                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {poDocTypes.map((type) => (
                      <MenuItem key={type.poDocumentTypeCode} value={type.poDocumentTypeCode}>
                        <Checkbox checked={selectedPoDocTypes.indexOf(type.poDocumentTypeCode) > -1} />
                        <ListItemText primary={type.poDocumentTypeCode} />
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {submitted && errors.poDocType && (
                  <Typography color="error" variant="caption" style={{ fontSize: 14 }}>
                    {errors.poDocType}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            {/* Purchasing Org Code / Description */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="purchasingOrg">
                  Purchasing Org Code / Description
                  {/* Purchasing Org Code / Description {!readOnly && <span style={{ color: "red" }}>*</span>} */}
                </Typography>
                {readOnly ? (
                  <div className={classes.selectionsBox} style={{fontFamily:'Inter'}}>
                    {Array.isArray(formData?.purchasingOrgList) && formData?.purchasingOrgList?.length > 0
                      ? formData.purchasingOrgList.map(org => `${org.code} / ${org.description}`).join(", \n")
                      : "N/A"}
                  </div>
                ) : (
                  <Select
                    id="purchasingOrg"
                    name="purchasingOrg"
                    multiple
                    value={selectedOrgs || ""}
                    onChange={handleOrgChange}
                    className={classes.selectContainer}
                    input={<OutlinedInput label="Purchasing Org Code / Description" notched={false} />}
                    renderValue={(selected) =>
                      selected.length === 0 ? "Select from the list" : selected.join(", \n")
                    }
                    fullWidth
                    required
                    sx={inputFieldStyles}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.purchasingOrg)}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      }
                    }}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {purchasingDetails?.purchasingOrgDetails?.map((org) => (
                      <MenuItem key={`${org.purchasingOrgCode} / ${org.purchasingOrgDescription}`}
                        value={`${org.purchasingOrgCode} / ${org.purchasingOrgDescription}`}>
                        <Checkbox checked={selectedOrgs.some(val => val.includes(`${org.purchasingOrgCode} / `))} />
                        <ListItemText primary={`${org.purchasingOrgCode} / ${org.purchasingOrgDescription}`} />
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {!readOnly && <div className={classes.selectionsBox}>
                  {selectedOrgs.length > 0 ? selectedOrgs.join(", \n") : "Your Selections"}
                </div>}
                {submitted && errors.purchasingOrg && (
                  <Typography color="error" variant="caption" style={{ fontSize: 14 }}>
                    {errors.purchasingOrg}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Purchasing Group Code / Description - Telephone */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="purchasingGroup">
                  Purchasing Group Code / Description - Telephone
                  {/* Purchasing Group Code / Description - Telephone {!readOnly && <span style={{ color: "red" }}>*</span>} */}
                </Typography>
                {readOnly ? (
                  <div className={classes.selectionsBox} style={{fontFamily:'Inter'}}>
                    {Array.isArray(formData?.purchasingGroupList) && formData?.purchasingGroupList?.length > 0
                      ? formData.purchasingGroupList.map(group => `${group.code} / ${group.description} - ${group.telephoneNbr}`).join(", \n")
                      : "N/A"}
                  </div>
                ) : (
                  <Select
                    id="purchasingGroup"
                    name="purchasingGroup"
                    multiple
                    value={selectedGroups}
                    onChange={handleGroupChange}
                    className={classes.selectContainer}
                    input={<OutlinedInput label="Purchasing Group Code / Description - Telephone" notched={false} />}
                    renderValue={(selected) =>
                      selected.length === 0 ? "Select from the list" : selected.join(", \n")
                    }
                    fullWidth
                    required
                    sx={inputFieldStyles}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.purchasingGroup)}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      }
                    }}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select from the list
                    </MenuItem>
                    {getAvailableGroups().map((group) => (
                      <MenuItem key={group} value={group}>
                        <Checkbox checked={selectedGroups.some(val => val.includes(group.split(' / ')[0] + ' / '))} />
                        <ListItemText primary={group} />
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {!readOnly && <div className={classes.selectionsBox}>
                  {selectedGroups.length > 0 ? selectedGroups.join(", \n") : "Your Selections"}
                </div>}
                {submitted && errors.purchasingGroup && (
                  <Typography color="error" variant="caption" style={{ fontSize: 14 }}>
                    {errors.purchasingGroup}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            {/* CMO ID from BMS ERP */}
            {/* <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="cmoIDFromSponsorERP">
                  CMO ID from BMS ERP {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
                {readOnly ? (
                  <Typography>
                    {formData?.cmoIDFromSponsorERP || "N/A"}
                  </Typography>
                ) : (
                  <TextField
                    id="cmoIDFromSponsorERP"
                    name="cmoIDFromSponsorERP"
                    value={stepData.cmoIDFromSponsorERP || ''}
                    onChange={handleCmoIdChange}
                    variant="outlined"
                    placeholder="Enter text here"
                    fullWidth
                    required
                    InputProps={{ style: commonInlineStyles.input }}
                    onInput={e => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-Z0-9\-_]/g, "")
                        .replace(/(-{2,}|_{2,})/g, (match) => match[0]);
                    }}
                    sx={inputFieldStyles}
                    inputProps={commonInlineStyles.inputProps}
                    style={commonInlineStyles.input}
                    error={submitted && Boolean(errors.cmoIDFromSponsorERP)}
                  />
                )}
                {submitted && errors.cmoIDFromSponsorERP && (
                  <Typography color="error" variant="caption" style={{ fontSize: 14 }}>
                    {errors.cmoIDFromSponsorERP}
                  </Typography>
                )}
              </FormControl>
            </Grid> */}

                          <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="cmoIDFromSponsorERP">
                  CMO ID from Sponsor ERP{" "}
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </Typography>
            
                {readOnly ? (
                  <Typography>{stepData.cmoIDFromSponsorERP || ""}</Typography>
                ) : (
                  <>
                    {cmoIds.map((id, index) => (
                      <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                        <TextField
                          id={`cmoIDFromSponsorERP-${index}`}
                          name={`cmoIDFromSponsorERP-${index}`}
                          value={id}
                          onChange={(e) => handleDynamicCmoIdChange(index, e.target.value)}
                          onBlur={(e) => {
                            const { value } = e.target;
                            // Trim leading and trailing spaces for string values
                            if (typeof value === "string" && value.trim() !== value) {
                              handleDynamicCmoIdChange(index, value.trim());
                            }
                          }}
                          variant="outlined"
                          placeholder="Enter text here"
                          fullWidth
                          required
                          // error={!!errors.cmoIDFromSponsorERP}
                          // helperText={errors.cmoIDFromSponsorERP || ""}
                          InputProps={{ style: commonInlineStyles.input }}
                          sx={inputFieldStyles}
                          inputProps={commonInlineStyles.inputProps}
                          style={commonInlineStyles.input}
                        />
                        {index > 0 && (
                          <IconButton onClick={() => handleRemoveCmoId(index)} style={{color:"red"}} aria-label="delete">
                            {/* <DeleteIcon /> */}
                            <DeleteOutlinedIcon />
                          </IconButton>
                        )}
                           {index === 0 && (
                        <IconButton onClick={() => handleAddCmoId(index)} style={{color:"black"}} aria-label="add">
                          <AddCircleOutlineIcon />
                        </IconButton>
                           )}
                      </div>
                    ))}
                                              {errors.cmoIDFromSponsorERP && (
                                 <Typography 
                              className={classes.errorText} 
                              style={{ 
                                fontSize: 14, 
                                color: "#f44336", 
                              }}
                            >
                         {errors.cmoIDFromSponsorERP}
                            </Typography>
                            )}
                  </>
                )}
              </FormControl>
            </Grid>

            {/* Plant IDs From Sponsor ERP */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="plantIDsFromSponsorERP">
                  Plant IDs From Sponsor ERP
                </Typography>
                <Typography>
                  {formData?.receivingPlantIDs && formData.receivingPlantIDs.length > 0 
                    ? formData.receivingPlantIDs.join(", ")
                    : ""}
                </Typography>
              </FormControl>
            </Grid>

            {/* Storage Location IDs From Sponsor ERP */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formField}>
                <Typography component="label" htmlFor="storageLocationIDsFromSponsorERP">
                  Storage Location IDs From Sponsor ERP
                </Typography>
                <Typography>
                  {formData?.receivingStorageLocationIDs && formData.receivingStorageLocationIDs.length > 0 
                    ? formData.receivingStorageLocationIDs.join(", ")
                    : ""}
                </Typography>
              </FormControl>
            </Grid>

          </Grid>
          {!hideStepActions && <div className="stepper-navigation-btns" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
            <Button startIcon={<ArrowBackIosIcon />} variant="outlined" color="default" onClick={handleBack} className={classes.backButton} disabled={loading}>
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleNextClick}
              className={classes.button}
              endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <ArrowForwardIosIcon />}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save & Next"}
            </Button>
          </div>}
        </form>
      </div>
    </div>
  );
};

export default PurchasingDetails;